import custPopover from '@/components/cust_components/cust_popover_component.vue';
import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import Vue from 'vue';
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)



import 'moment-timezone';
export default {
    name: 'CategoryComp',
    components:{
        custPopover,
        headerComponent,
        FooterComponent,
        LoaderPopover,
    },
    data(){
        return {
            mobile_view : false,
            category_services_array:[],
            services_array:[],
            search: '',
            search_service_details:false,
            search_validation:'',
            session_service_details : [],
            title: this.$route.params.store_name,
            store_name : '',
            filteredList : [],
            store_details : {},
            store_popup : false,
            block_customer_popup : false,
            popup_mobile :'',
            banned: 0 ,
            more_content : false,
            not_exist_store_name: false,
            api:'',
        }
    },
    created(){
        if(localStorage.getItem('remove_session_flag')){
            this.$session.remove('store_details');
            this.$session.remove('service_obj');
            this.$session.remove('product_obj');
            this.$session.remove('unpaid_booking_details');
            localStorage.removeItem('remove_session_flag');
        }
        if (window.location.hostname === 'localhost') {
            this.api =  '/';
        } else {
            this.api =  '/v2/';
        }
    },
    async mounted(){
        this.$session.remove('unpaid_booking_details');
        try{
            await this.getServicesByCategories();
        }catch(error){
            if (error.response) {
                console.log(error.response.data); // => the response payload 
            }
        }        
        if(this.$store.state.store_url_name){
            if(this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0 && (this.$store.state.store_url_name.toLowerCase() != this.title.toLowerCase()))   {
               this.store_popup = true;
            }
            else{
                try{
                    await this.getStoreDetails(); 
                }catch(error){
                    if (error.response) {
                        console.log(error.response.data); // => the response payload 
                    }
                }
            }
        }else{
           try{
                await this.getStoreDetails(); 
            }catch(error){
                if (error.response) {
                    console.log(error.response.data); // => the response payload 
                }
            }
        }   
        let storedetails_array = this.$store.state.cust_store_data;
        this.store_details = JSON.stringify({
            store_id        :  storedetails_array.store_id,
            store_name      :  storedetails_array.store_url_name,
            store_mobile    :  storedetails_array.store_tel,
            store_publish_key   :  storedetails_array.store_api_publish_key,
        });
        this.$session.set('store_details',  this.store_details);
        this.popup_mobile = storedetails_array.store_tel; 
        this.$ga.page(this.$router); 
        if(this.$session.get('cust_details')) {
            if(JSON.parse(this.$session.get('store_details')).store_id)
                await this.$store.dispatch('checkBlockCustomer',[this.$store.state.api,JSON.parse(this.$session.get('cust_details')).cust_email,JSON.parse(this.$session.get('store_details')).store_id])  
            if(this.$store.state.block_customer_data.length>0){
                let banned_data = {
                    "owner_cust_id" : this.$store.state.block_customer_data[0].cust_id,
                    "pay_fullpayment" : this.$store.state.block_customer_data[0].pay_fullpayment,
                    "cust_banned" :  this.$store.state.block_customer_data[0].is_banned
                }
                this.$session.set('cust_banned_data', JSON.stringify(banned_data));
            }
           
        }
          
        if(this.$session.get('service_obj')){
            let edit_flag_present = JSON.parse(this.$session.get('service_obj')).some(cart_serv => Object.keys(cart_serv).includes('edit_flag'));
            if(edit_flag_present){
                this.$session.remove('service_obj');
                this.$session.remove('product_obj');
            }
        }

        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.add_buttons_toggle();
        if(this.$session.get('product_obj')){
            this.$store.state.total_products_in_cart = JSON.parse(this.$session.get('product_obj')).length;
        }
       
        this.$store.state.total_services_in_cart = this.session_service_details.length;
    },

    watch: {
        search:function(){
            if(this.search.length > 2){
                this.filteredList = this.services_array.filter(services => {
                                       return services.serv_name.toLowerCase().includes(this.search.toLowerCase())
                                    })
            }
            else{  
                this.filteredList =  [] ;
            }    
            let _this = this
            window.setTimeout(function(){
                _this.add_buttons_toggle();
            },100);

            this.filteredList.forEach(serv => {
                var n = serv.serv_name.toLowerCase().search(this.search.toLowerCase());
                serv.search_value = n;
            })

            this.filteredList.sort(function (a, b) {
                return a.search_value - b.search_value;
            }); 
        },
    },

    methods:{
        add_buttons_toggle(){
            if(this.$session.get('service_obj')){
                this.session_service_details = JSON.parse(this.$session.get('service_obj'));
                this.session_service_details.forEach((session_serv) => {
                    let service_element = document.getElementsByClassName("add_button_"+session_serv.serv_id)
                    if(service_element.length){
                        service_element[0].innerHTML = " Added";
                        service_element[0].className += " btn-pink";
                        service_element[0].disabled = "true"
                    }
                   
                })
            }
        },
        
        async addServices(serv_cat_id, serv_id){
            this.$store.state.loader_popup = true;
            if(this.$session.get('cust_details')){
                if(this.$session.get('cust_banned_data')){
                    if(JSON.parse(this.$session.get('cust_banned_data')).cust_banned == 0){
                        this.redirectCartPage(serv_cat_id, serv_id)  
                    }
                    else{
                        this.$store.state.loader_popup = false;
                        this.block_customer_popup = true;   
                    }
                }else{
                   this.redirectCartPage(serv_cat_id, serv_id)
                }  
            }else{
                this.redirectCartPage(serv_cat_id, serv_id)
            }    
            
        },

        redirectCartPage(serv_cat_id, serv_id){
            let serv_obj = [];
    
            if(this.$session.get('service_obj')){
                serv_obj = JSON.parse(this.$session.get('service_obj')) ;
            }
           
            this.category_services_array.forEach((category)=>{
                if(category.serv_cat_id == serv_cat_id){
                    category.services.forEach((service)=>{
                        if(service.serv_id == serv_id){
                            serv_obj.push(service);
                        }
                    })
                }
            })
            this.$store.state.total_services_in_cart = serv_obj.length;
            this.$session.set('service_obj', JSON.stringify(serv_obj));

            this.$store.state.loader_popup = false;
            this.$router.push('/cart');
        },

        search_services(){
            this.search_validation=''
            if(this.search.length<=2 && this.search.length > 0){
                this.search_validation = 'Type in at least 3 alphabets to search for services.';
            }
        },

        remove_search(){
            this.search = '';
        },

        
        async getServicesByCategories(){
            this.$store.state.loader_popup = true;
            try{
                await this.$store.dispatch('getServicesByCategories',[this.$store.state.api,this.$route.params.store_name])
                let categories_array = this.$store.state.cust_services_data;
                for(let i=0; i<categories_array.services_details.length;i++){
                    if(categories_array.services_details[i].services.length>0)
                    {
                        this.category_services_array.push(categories_array.services_details[i])
                    }
                    
                }
                for(let j=0; j<this.category_services_array.length; j++){
                    
                    for(let k=0; k<this.category_services_array[j].services.length; k++){
                        this.services_array.push(this.category_services_array[j].services[k]);
                    }
                }
                this.$store.state.loader_popup = false;
            }catch(e)
            {
                this.not_exist_store_name = true;
                this.$store.state.loader_popup = false;
            }
            
        },

        async getStoreDetails(){
            await this.$store.dispatch('getStoreDetails',[this.$store.state.api,this.$route.params.store_name])
            if(Object.keys(this.$store.state.cust_store_data).length > 0){
                this.store_data = this.$store.state.cust_store_data;
                this.store_name =  this.store_data.store_name
                this.$session.set('store_url_name', this.$route.params.store_name);
                this.$store.commit('storeUrlName', this.$route.params.store_name)
            }else{
                this.store_data = [];
            }
        },
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },

        open_service(serv_cat_id, serv_id, store_id){
            let serv_obj = {'serv_cat_id': serv_cat_id,'serv_id': serv_id, 'store_id': store_id, 'store_name' : this.title };

            var serv_encrypt_code = this.CryptoJS.AES.encrypt(JSON.stringify(serv_obj),this.Constants.CRYPTO_KEY).toString().replace(/\+/g,'xMl3Jk').replace(/\//g,'Por21Ld').replace(/=/g,'Ml32');
           
            this.$router.push('/service/'+serv_encrypt_code+'/'+this.title);
        },

        categories_continue(){
            this.$router.push('/cart'); 
        },

        close_store_popup(){
            this.store_popup = false;
        },

        close_block_customer_popup(){
            this.block_customer_popup = false;
        },

        continue_popup(){
            this.$session.remove('service_obj');
            this.$session.remove('product_obj');
            this.$session.remove('unpaid_booking_details');
            this.$session.remove('store_details');
            this.$session.set('store_url_name', this.$route.params.store_name);
            this.$store.commit('storeUrlName', this.$route.params.store_name);
            this.store_popup = false;
        },

        redirect_home(){
            window.location.href = this.api + "home/"+ this.$store.state.store_url_name;
        }

        

    },
    filters: {
        content_less: function(content){
            return content.substr(0, 150);
        },
        
    }
   
}